/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useRef, useState} from "react";
import {DragDropContext, Droppable, Draggable} from "react-beautiful-dnd";
import useApiEstaciones from "../../api/catalogos/useApiEstaciones";
import {updateArrayAtIndex} from "../../shared/arrayUtility";
import {dateToString, numberFormat} from "../../shared/format";
import {Button} from "primereact/button";
import InfoViaje from "./InfoViaje";
import _ from "lodash";
import {reorder} from "../../shared/DragAndDropUtility";


/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    const [removed] = sourceClone.splice(droppableSource.index, 1);
    destClone.splice(droppableDestination.index, 0, removed);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;
};
const getItemStyle = (isDragging, draggableStyle,fueMovido) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 4,
    margin: `0 0 4px 0`,

    // change background colour if dragging
    background: isDragging ? "lightgreen" : fueMovido ? "lightgreen" : "white",


    // styles we need to apply on draggables
    ...draggableStyle
});
const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "transparent",
    width: 130,
    flexGrow: 1,
    border: '1px solid lightgrey'
});

function ViajeEstaciones() {
    const [state, setState] = useState([]);
    const [viaje, setViaje] = useState({})
    const [totales, setTotales] = useState({sugeridosPorEstacion:{}})
    const [viajesMovidos, setViajesMovidos] = useState(new Set());
    const api = useApiEstaciones();
    const [origenPorViaje, setOrigenPorViaje] = useState({});
    const op = useRef(null);

    const load = async () => {
        const data = await api.viajes()
        setState(data)

        const viajes =  _.sum(data.map(e=>e.viajes.length))
        const estaciones = data.length;

        if (estaciones === 0)
            return;

        const promedio = viajes/estaciones;

        setTotales( {viajes, promedio, sugeridosPorEstacion: {min: Math.round(promedio-5),max: Math.round(promedio+5)}  })

        const idsGuardados = JSON.parse(localStorage.getItem("viajesMovidos") || "[]");
        const allViajeIds = new Set(data.flatMap(e => e.viajes.map(v => `${v.viajeId}`)));
    
        const filtrados = idsGuardados.filter(id => allViajeIds.has(id));
        setViajesMovidos(new Set(filtrados));
        localStorage.setItem("viajesMovidos", JSON.stringify(filtrados));

        const storedOrigenes = JSON.parse(localStorage.getItem("origenPorViaje") || "{}");
        const nuevosOrigenes = {...storedOrigenes};
        
        data.forEach(est => {
            est.viajes.forEach(v => {
                if (!nuevosOrigenes[v.viajeId]) {
                    nuevosOrigenes[v.viajeId] = est.id;
                }
            });
        });
        
        setOrigenPorViaje(nuevosOrigenes);
        localStorage.setItem("origenPorViaje", JSON.stringify(nuevosOrigenes));
        
        
    }

    useEffect(() => {
        const inicializar = async () => {
            const data = await api.viajes();
            setState(data);
    
            const viajes = _.sum(data.map(e => e.viajes.length));
            const estaciones = data.length;
    
            if (estaciones === 0) return;
    
            const promedio = viajes / estaciones;
            setTotales({
                viajes,
                promedio,
                sugeridosPorEstacion: {
                    min: Math.round(promedio - 5),
                    max: Math.round(promedio + 5),
                }
            });
    
            // 🔄 Recupera y limpia los viajes movidos
            const idsGuardados = JSON.parse(localStorage.getItem("viajesMovidos") || "[]");
            const allViajeIds = new Set(data.flatMap(e => e.viajes.map(v => `${v.viajeId}`)));
    
            const filtrados = idsGuardados.filter(id => allViajeIds.has(id));
            setViajesMovidos(new Set(filtrados));
            localStorage.setItem("viajesMovidos", JSON.stringify(filtrados));
        };
    
        inicializar();
    
        const interval = setInterval(() => {
            load().then();
        }, 300000);
    
        return () => clearInterval(interval);
    }, []);
    
    useEffect(() => {
        const guardados = localStorage.getItem("origenPorViaje");
        if (guardados) {
          setOrigenPorViaje(JSON.parse(guardados));
        }
      }, []);
    const onDragEnd = async (result) => {
        const {source, destination} = result;

        // dropped outside the list
        if (!destination) {
            return;
        }
        const sInd = +source.droppableId;
        const dInd = +destination.droppableId;

        if (sInd === dInd) {
            let estacion = state[sInd]
            const viajes = reorder(estacion.viajes, source.index, destination.index);
            estacion = {...estacion, viajes};
            setState(updateArrayAtIndex(state, sInd, estacion));
        } else {
            let estacionOrigen = state[sInd];
            const viaje = estacionOrigen.viajes[source.index];
            let estacionDestino = state[dInd]
            const result = move(estacionOrigen.viajes, estacionDestino.viajes, source, destination);
            const newState = [...state];
            newState[sInd] = {...estacionOrigen, viajes : result[sInd], cantidadViajes:result[sInd].length};
            newState[dInd] = {...estacionDestino, viajes: result[dInd], cantidadViajes: result[dInd].length};
            setState(newState);
            await api.asignarEstacion(estacionDestino.id, viaje.viajeId)
            setViajesMovidos(prev => {
                const nuevoSet = new Set(prev).add(`${viaje.viajeId}`);
                localStorage.setItem("viajesMovidos", JSON.stringify(Array.from(nuevoSet)));
                return nuevoSet;
            });
            setOrigenPorViaje(prev => {
                // Solo guarda el origen si no está definido aún
                if (prev[viaje.viajeId]) return prev;
            
                const updated = {
                    ...prev,
                    [viaje.viajeId]: estacionOrigen.id,
                };
                localStorage.setItem("origenPorViaje", JSON.stringify(updated));
                return updated;
            });           

        }
    }

    const onShowViaje =(e, viaje) =>{
        op.current.toggle(e)
        setViaje(viaje)
    }

    const getHeaderColor = (value)=>{
        if (value >= totales.sugeridosPorEstacion.min  && value <= totales.sugeridosPorEstacion.max)
            return '#4b6fdb';
        return '#b43b3b';

    }
  
    const resetViajesAOrigen = async (estacionId) => {
        const nuevoEstado = [...state];
        const viajesPorId = {};

        nuevoEstado.forEach(est => {
            est.viajes.forEach(v => {
                viajesPorId[v.viajeId] = {...v, estacionActualId: est.id};
            });
        });

        const viajesParaRegresar = [];

        nuevoEstado.find(e => e.id === estacionId)?.viajes.forEach(v => {
            const origenId = origenPorViaje[v.viajeId];
            if (origenId && origenId !== estacionId) {
                viajesParaRegresar.push({
                    viajeId: v.viajeId,
                    estacionActualId: estacionId,
                    estacionId: origenId,
                });
            }
        });

        Array.from(viajesMovidos).forEach(id => {
            const viajeId = parseInt(id);
            const origenId = origenPorViaje[viajeId];
            const actual = viajesPorId[viajeId];
            if (origenId === estacionId && actual?.estacionActualId !== estacionId) {
                viajesParaRegresar.push({
                    viajeId,
                    estacionActualId: actual.estacionActualId,
                    estacionId: estacionId,
                });
            }
        });
        // También regresar viajes que no fueron movidos, pero están mal ubicados
        nuevoEstado.find(e => e.id === estacionId)?.viajes.forEach(v => {
            const origenId = origenPorViaje[v.viajeId];
            // Si el viaje está aquí pero debería estar en otro lado (según origen)
            if (origenId && origenId !== estacionId && !viajesMovidos.has(`${v.viajeId}`)) {
                viajesParaRegresar.push({
                    viajeId: v.viajeId,
                    estacionActualId: estacionId,
                    estacionId: origenId,
                });
            }
        });
        const vistos = new Set();
        const unicos = viajesParaRegresar.filter(v => {
            if (vistos.has(v.viajeId)) return false;
            vistos.add(v.viajeId);
            return true;
        });

        if (unicos.length === 0) return;

        try {
            await api.limpiarEstacion(unicos);
            unicos.forEach(({viajeId, estacionActualId, estacionId}) => {
                const viaje = viajesPorId[viajeId];
                const origenIdx = nuevoEstado.findIndex(e => e.id === estacionActualId);
                const destinoIdx = nuevoEstado.findIndex(e => e.id === estacionId);

                if (origenIdx !== -1) {
                    nuevoEstado[origenIdx].viajes = nuevoEstado[origenIdx].viajes.filter(v => v.viajeId !== viajeId);
                    nuevoEstado[origenIdx].cantidadViajes = nuevoEstado[origenIdx].viajes.length;
                }

                if (destinoIdx !== -1 && viaje) {
                    nuevoEstado[destinoIdx].viajes.push(viaje);
                    nuevoEstado[destinoIdx].cantidadViajes = nuevoEstado[destinoIdx].viajes.length;
                }
            });

            const nuevoViajesMovidos = new Set(viajesMovidos);
            const nuevoOrigenPorViaje = {...origenPorViaje};

            unicos.forEach(({viajeId}) => {
                nuevoViajesMovidos.delete(`${viajeId}`);
                delete nuevoOrigenPorViaje[viajeId];
            });

            setState(nuevoEstado);
            setViajesMovidos(nuevoViajesMovidos);
            setOrigenPorViaje(nuevoOrigenPorViaje);
            localStorage.setItem("viajesMovidos", JSON.stringify(Array.from(nuevoViajesMovidos)));
            localStorage.setItem("origenPorViaje", JSON.stringify(nuevoOrigenPorViaje));
        } catch (error) {
            console.error("Error al regresar los viajes:", error);
        }

        await load();
    };
      
    const actualizarEstacion= async ()=>{
        await api.actualizarEstacionViaje()
        await load();
    }
      
    return (
        <>
            <div className={'viaje-estaciones-header'}>
                <span className={'text-label'}>
                    Total Viajes:
                </span>
                <span className={'text-value'}>
                    {totales.viajes}
                </span>
                <span className={'text-label'} style={{marginLeft:'10px'}}>
                    Promedio Viajes:
                </span>
                <span className={'text-value'}>
                    {numberFormat(totales.promedio)}
                </span>
                <span className={'text-label'} style={{marginLeft:'10px'}}>
                    Sugeridos Por Estacion:
                </span>
                <span className={'text-value'}>
                    {totales.sugeridosPorEstacion.min} - {totales.sugeridosPorEstacion.max}
                </span>
                <span className={'text-value'}>
                {/* Actualizar estacion a viajes activos con nueva estacion. */}
                <Button 
                        label="Asignar estación"
                        icon="pi pi-cog"
                        iconPos="right"
                        className="p-button-sm p-button-text"
                        onClick={() => actualizarEstacion()}
                        tooltip="Actualizar estación"
                        style={{ marginLeft: '10px', marginTop: '-8px' }}
                    />

                </span>
            </div>
            
            <div className="contenedor-scroll">
                
                <DragDropContext onDragEnd={onDragEnd}>
                    {state.map((el, ind) => (
                        <React.Fragment key={el.id}>
                            
                            <div className={'estacion'}>
                            <div className={'estacion-header'} style={{ 
                                    color: getHeaderColor(el.viajes.length), 
                                    position: 'relative',
                                    paddingRight: '2.0rem',
                                    paddingTop: '8px',
                                    paddingBottom: '4px'
                                }}>                                                    
                                 <span>{el.nombre}</span> <span className={'unidades'}>({el.cantidadViajes} viajes)</span>                                
                                <Button 
                                icon="pi pi-cog" 
                                className="p-button-rounded p-button-sm p-button-text" 
                                onClick={() => resetViajesAOrigen(el.id)}
                                tooltip="Actualizar estación" style={{
                                    position: 'absolute',
                                    top: 0,
                                    right: 0
                                }}
                            
                            />
                            </div>
                            <Droppable droppableId={`${ind}`}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        style={getListStyle(snapshot.isDraggingOver)}
                                        {...provided.droppableProps}
                                    >
                                        {el.viajes.map((item, index) => (
                                            <Draggable
                                                key={item.viajeId}
                                                draggableId={`${item.viajeId}`}
                                                index={index}
                                            >
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                            snapshot.isDragging,
                                                            provided.draggableProps.style,
                                                            viajesMovidos.has(`${item.viajeId}`)
                                                        )}
                                                    >
                                                        <div className={'estacion-viaje'}>
                                                            <span className={'unidad'}>{item.unidad}</span>
                                                            {/*<span>{item.cartaPorte}</span>*/}
                                                            <div>{dateToString(item.fecha)}</div>
                                                            <div className={'cliente'}>{item.cliente}</div>
                                                            <span className={'info'} onClick={(e)=> onShowViaje(e,item) }>
                                                                 <Button icon="pi pi-info-circle" className="p-button-rounded p-button-info p-button-text" />
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                            </div>
                        </React.Fragment>
                    ))}
                </DragDropContext>
            </div>
            <InfoViaje refViaje={op} viaje={viaje}>

            </InfoViaje>
        </>
    );
}


export default ViajeEstaciones